import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { Button } from './Button';
import './AboutSection.css';

function AboutSection() {
  return (
    <div className='about-container'>
      <img src='/images/wallpaper55.png' />
      
      <h2 className="about-title">About Me</h2>

      <div class="card">
        
    <p class="card-text">I am Emre, a highly motivated software developer with a strong focus on 
        frontend development and testing. Originally from North Macedonia and currently 
        based in Germany, I hold a bachelor's degree in Computer Science Engineering, which 
        has equipped me with a solid understanding of software principles and engineering practices.
        As a dedicated developer, I am constantly seeking opportunities to further enhance my expertise 
        and stay up-to-date with the latest advancements in the field.</p>
  </div>
      
    </div>
  );
}

export default AboutSection;
